import { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { routes } from '~src/routingConfig';
import { StoreI } from '~src/rootReducer';
import { SessionUserI } from '~src/interfaces/session.types';
import { Uuid } from '~src/services/uuid';

interface StateProps {
  sessionUser: SessionUserI;
}

const SessionUserProfileRedirect: FC<StateProps> = props => (
  <Redirect to={routes.reports.user(Uuid.fromHexString(props.sessionUser.uuid))} />
);

const mapState2Props = ({ user }: StoreI): StateProps => ({
  sessionUser: user.session.user!,
});

const SessionUserProfileRedirectC = connect(mapState2Props)(SessionUserProfileRedirect);

export default SessionUserProfileRedirectC;
